import { Client, Server } from 'styletron-engine-monolithic';
var getHydrateClass = function getHydrateClass() {
  return document.getElementsByClassName('_styletron_hydrate_');
};
export var styletron = typeof window === 'undefined' ? new Server() : new Client({
  hydrate: getHydrateClass()
});